import { Button, Form } from "rsuite";
import { useState } from "react";
import {
  AdminAddFormType,
  AdminAddFormSchema,
  AdminAddDefaultValues,
} from "../../models/forms/adminAddForm";
import { ApiAdmin } from "../../core/apis/admin";
import { AppRoutesUI } from "../../config/appRoutes";
import { showSuccessToast, showErrorToast } from "../generic/toast.component";
import { useNavigate } from "react-router-dom";
import { AddForm } from "../generic/forms/addProfile/addProfileComponent";

export const AddAdmin = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formValue, setFormValue] = useState<AdminAddFormType>(
    AdminAddDefaultValues
  );
  const navigate = useNavigate();

  const handleSave = async (checked: boolean) => {
    const role = "Admin";
    if (!checked) return;
    setIsLoading(true);
    const hasAtLeastOneCapLetter =
      /[A-Z]/.test(formValue.password ?? "") &&
      /[A-Z]/.test(formValue.confPassword ?? "");
    const hasAtLeastOneNumber =
      /[0-9]/.test(formValue.password ?? "") &&
      /[0-9]/.test(formValue.confPassword ?? "");
    if (formValue.password !== formValue.confPassword) {
      showErrorToast("Passwords don't match!");
      setIsLoading(false);
      return;
    } else if (
      (formValue.password && formValue.password?.length < 8) ||
      (formValue.confPassword && formValue.confPassword?.length < 8) ||
      !hasAtLeastOneCapLetter ||
      !hasAtLeastOneNumber
    ) {
      showErrorToast(
        "Password must be at least 8 characters (at least 1 number and 1 capital letter)"
      );
      setIsLoading(false);
      return;
    } else {
      try {
        await ApiAdmin.createAdmin(
          formValue.email || "",
          formValue.userName || "",
          formValue.password || "",
          formValue.confPassword || "",
          formValue.firstName || "",
          formValue.lastName || "",
          formValue.companyName || "",
          formValue.address || "",
          formValue.state || "",
          formValue.countryId || "",
          role
        );
        showSuccessToast("Admin Created Successfully");
      } catch (error: any) {
        showErrorToast(error.response?.data?.Message || error.message);
      }
      navigate(AppRoutesUI.Admins.AdminList());
      setFormValue(AdminAddDefaultValues);
      setIsLoading(false);
    }
  };
  return (
    <div className="email-card">
      <Form
        formValue={formValue}
        onChange={setFormValue}
        model={AdminAddFormSchema}
        onSubmit={handleSave}
        fluid
      >
        <AddForm />
        <div className="d-flex justify-content-end align-items-center">
          <Button
            size="sm"
            appearance="primary"
            className="m-2 me-3 form-buttons"
            type="submit"
            loading={isLoading}
          >
            Create
          </Button>
        </div>
      </Form>
    </div>
  );
};
